import axios, { type AxiosInstance } from 'axios';
import { env } from '@shared/config/env';

export const httpClient: AxiosInstance = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
  },
});

export const csrfClient: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  withCredentials: true,
});
